// extracted by mini-css-extract-plugin
export default {"info":"bWBq5YO2l52v5v4jlzKj"};